import {styled} from "@mui/material/styles";
import {Box} from "@mui/material";

export const StyledMain = styled(Box)(({ theme }: any) => ({
  '& .main-content': {
    margin: '0 !important',
    padding: '0 !important',
  },
  '& .container-fluid': {
    padding: '0 !important',
  },
  '& .main-landing': {
    margin: '0 !important',
    width: '100% !important',
    display: 'grid !important',
    gridTemplateColumns: 'auto 1fr !important',
    '.dash-content, .overview_theme': {
      maxWidth: '100% !important',
      minWidth: 'calc(100vw - 250px)!important',
      [theme.breakpoints.down('md')]: {
        minWidth: '100vw !important',
      },
      '&.bg-white': {
        background: 'white !important',
      },
      '.common-padding': {
        padding: '0px 40px 8px 32px !important',
        background: 'transparent !important',
        maxWidth: '98vw',
        [theme.breakpoints.down('md')]: {
          padding: '0px 12px 8px 12px !important',
        }
      },
      '.list-content': {
        background: 'transparent !important',
      },
    },
  },
}));
